import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=0f53032c&scoped=true&"
var script = {}
import style0 from "./Page.vue?vue&type=style&index=0&id=0f53032c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f53032c",
  null
  
)

export default component.exports